import _ from 'lodash';

const analyticsTypes = {
  ALERT_ACTION_LINK_CLICK: 'alert_ActionLinkClick'
};

/*
    Helper functions to extract information for each of the actions
*/
const extractAlertValues = (alert, extra) => ({
  alert_id: _.get(alert, 'id'),
  alert_kind: _.get(alert, 'kind'),
  alert_level: _.get(alert, 'level'),
  alert_content: _.get(alert, 'content'),
  alert_action_link: _.get(alert, 'action_link'),
  ...extra
});

const analyticsActions = [{
  type: analyticsTypes.ALERT_ACTION_LINK_CLICK,
  attributesExtractor: extractAlertValues
}];

export {
  analyticsTypes,
  analyticsActions
};
